import { makeAutoObservable, runInAction } from "mobx";
import IStudent, { IStudentTicket } from "../../models/student";
import Subjects from "../../models/subjects";
import ITicketStatistic from "../../models/ticket-statistic";
import { StudentService } from "../../services/student-service";
import { message } from "antd";

export class StudentTicketStore {

    data: IStudentTicket;

    constructor(data: IStudentTicket) {
        this.data = data;
        makeAutoObservable(this);
    }
}

export default class StudentItemStore {

    data: IStudent;
    expandedStatistic: boolean;
    expandedTicketList: boolean;
    subject: Subjects;
    statistic: ITicketStatistic[];
    egeTickets: StudentTicketStore[];
    thematicTickets: StudentTicketStore[];
    notFinishedTickets: StudentTicketStore[];
    studentService: StudentService;

    constructor(data: IStudent, subject: Subjects) {

        this.data = data;
        this.expandedStatistic = false;
        this.expandedTicketList = false;
        this.subject = subject;
        this.statistic = [];
        this.egeTickets = [];
        this.thematicTickets = [];
        this.notFinishedTickets = [];
        this.studentService = new StudentService(subject);

        makeAutoObservable(this);
    }

    toggleStatistic() {

        if (!this.expandedStatistic) {

            try {

                this.studentService.loadTicketStatistic(
                    this.data.id,
                    data => {
                        this.statistic = data['content'] as ITicketStatistic[];
                        this.expandedStatistic = true;
                    }
                );

            } catch (error) {
                runInAction(() => { message.error(error) });
            }
        } else {
            this.expandedStatistic = false;
        }
    }

    getShortName() {
        return this.data.name.substring(0, 2);
    }

    loadTicketList() {

        if (!this.expandedTicketList) {

            try {

                this.studentService.loadTickets(
                    this.data.id,
                    data => {
                        this.egeTickets = (data['egeTickets'] as IStudentTicket[])?.map(t => new StudentTicketStore(t));
                        this.thematicTickets = (data['thematicTickets'] as IStudentTicket[])?.map(t => new StudentTicketStore(t));
                        this.notFinishedTickets = (data['notFinishedTickets'] as IStudentTicket[])?.map(t => new StudentTicketStore(t));
                        this.expandedTicketList = true;
                    }
                );

            } catch (error) {
                runInAction(() => { message.error(error) });
            }

        } else {
            this.expandedTicketList = false;
        }
    }

    unassign(completedTicketId: number) {
        
        this.studentService.unassignTicket(completedTicketId, _ => {
            const filter = (t: StudentTicketStore): boolean => t.data.id != completedTicketId;
            this.egeTickets = this.egeTickets.filter(filter);
            this.thematicTickets = this.thematicTickets.filter(filter);
            this.notFinishedTickets = this.notFinishedTickets.filter(filter);
        });
    }
}